// Wedding-O-Mat Questions - Complete Set of 15 Questions

import { CLIMATE, SCENARIOS, CULTURAL_ASPECTS, AMBIANCE, ACCOMMODATION, SEASONS } from '../shared/constants';

export const questions = [
  // SECTION 1: ZIELGEBIETSLOGIK (Destination Logic) - Questions 1-8
  
  {
    id: 'q1',
    section: 'destination',
    question: 'In welchem Zeitraum möchten Sie heiraten?',
    options: [
      { value: SEASONS.JAN_FEB, label: 'Januar - Februar' },
      { value: SEASONS.MAR_APR, label: 'März - April' },
      { value: SEASONS.MAY_JUN, label: 'Mai - Juni' },
      { value: SEASONS.JUL_AUG, label: 'Juli - August' },
      { value: SEASONS.SEP_OCT, label: 'September - Oktober' },
      { value: SEASONS.NOV_DEC, label: 'November - Dezember' }
    ]
  },
  {
    id: 'q2',
    section: 'destination',
    question: 'Wie weit möchten Sie für Ihre Hochzeit reisen?',
    options: [
      { value: '1', label: 'Nah (z.B. Europa)' },
      { value: '2', label: 'Mittel (z.B. Nordafrika, Naher Osten)' },
      { value: '3', label: 'Fern (z.B. Asien, Afrika)' },
      { value: '4', label: 'Weit (z.B. Amerika, Ozeanien)' }
    ]
  },
  {
    id: 'q3',
    section: 'destination',
    question: 'Welche kulturellen Aspekte sprechen Sie an?',
    options: [
      { value: CULTURAL_ASPECTS.YOGA, label: 'Yoga & Spiritualität' },
      { value: CULTURAL_ASPECTS.DANCE, label: 'Tanz & Musik' },
      { value: CULTURAL_ASPECTS.CULINARY, label: 'Kulinarik & Wein' },
      { value: CULTURAL_ASPECTS.ART, label: 'Kunst & Design' }
    ]
  },
  {
    id: 'q4',
    section: 'destination',
    question: 'Welches Klima bevorzugen Sie?',
    options: [
      { value: CLIMATE.TROPICAL, label: 'Tropisch & Warm' },
      { value: CLIMATE.MEDITERRANEAN, label: 'Mediterran & Mild' },
      { value: CLIMATE.TEMPERATE, label: 'Gemäßigt & Kühl' },
      { value: CLIMATE.DRY, label: 'Trocken & Sonnig' },
      { value: CLIMATE.ALPINE, label: 'Alpin & Polar' }
    ]
  },
  {
    id: 'q5',
    section: 'destination',
    question: 'Welches Szenario wünschen Sie sich für Ihre Hochzeit?',
    options: [
      { value: SCENARIOS.BEACH, label: 'Strand' },
      { value: SCENARIOS.RAINFOREST, label: 'Regenwald' },
      { value: SCENARIOS.MOUNTAINS, label: 'Berge' },
      { value: SCENARIOS.CITY, label: 'City' },
      { value: SCENARIOS.DESERT, label: 'Wüste' }
    ]
  },
  {
    id: 'q6',
    section: 'destination',
    question: 'Wie viele Gäste erwarten Sie?',
    options: [
      { value: 'zu_zweit', label: 'Wir sind nur zu zweit' },
      { value: 'ca_15', label: 'Ca. 15 Gäste' },
      { value: 'ca_25', label: 'Ca. 25 Gäste' },
      { value: 'ca_40', label: 'Ca. 40 Gäste' },
      { value: 'mehr_40', label: 'Mehr als 40 Gäste' }
    ]
  },
  {
    id: 'q7',
    section: 'destination',
    question: 'Wie viele Tage soll Ihre Hochzeitsfeier dauern?',
    options: [
      { value: '1', label: '1 Tag' },
      { value: '2', label: '2 Tage' },
      { value: '3', label: '3 Tage' },
      { value: '4', label: '4 Tage' }
    ]
  },
  {
    id: 'q8',
    section: 'destination',
    question: 'Was ist Ihr Budget für die Hochzeit?',
    options: [
      { value: 'bis_25k', label: 'Bis 25.000€' },
      { value: '25_40k', label: '25.001€ - 40.000€' },
      { value: '40_60k', label: '40.001€ - 60.000€' },
      { value: '60_90k', label: '60.001€ - 90.000€' }
    ]
  },
  
  // VIDEO PLACEHOLDER - Will be shown between Q8 and Q9
  
  // SECTION 2: ERLEBNISPROFIL (Experience Profile) - Questions 9-15
  
  {
    id: 'q9',
    section: 'experience',
    question: 'Welche Art der Trauung bevorzugen Sie?',
    options: [
      { value: 'Freie_Trauung', label: 'Freie Trauung im Freien' },
      { value: 'Standesamt', label: 'Standesamtliche Hochzeit' },
      { value: 'Kirchlich', label: 'Kirchliche Trauung' },
      { value: 'Zeremoniell', label: 'Zeremonielle Trauung' },
      { value: 'Roadtrip', label: 'Roadtrip-Trauung mit Etappen' }
    ]
  },
  {
    id: 'q10',
    section: 'experience',
    question: 'Welcher Stil der Dekoration gefällt Ihnen?',
    options: [
      { value: 'Elegant', label: 'Elegant' },
      { value: 'Boho', label: 'Boho' },
      { value: 'Romantisch', label: 'Romantisch' },
      { value: 'Vintage', label: 'Vintage' },
      { value: 'Spirituell', label: 'Spirituell' }
    ]
  },
  {
    id: 'q11',
    section: 'experience',
    question: 'Welches Ambiente wünschen Sie sich für die Location?',
    options: [
      { value: AMBIANCE.RUSTIC, label: 'Rustikal' },
      { value: AMBIANCE.MODERN, label: 'Modern' },
      { value: AMBIANCE.EXOTIC, label: 'Exotisch' },
      { value: AMBIANCE.ROYAL, label: 'Royal' }
    ]
  },
  {
    id: 'q12',
    section: 'experience',
    question: 'Wie außergewöhnlich soll Ihre Hochzeit sein?',
    options: [
      { value: 'Klassisch', label: 'Klassisch & Traditionell' },
      { value: 'Individuell', label: 'Individuell & Persönlich' },
      { value: 'Stylish', label: 'Stylish & Trendig' },
      { value: 'Abenteuerlich', label: 'Abenteuerlich & Spannend' },
      { value: 'Verrückt', label: 'Verrückt & Unvergesslich' }
    ]
  },
  {
    id: 'q13',
    section: 'experience',
    question: 'Was ist Ihnen wichtiger?',
    options: [
      { value: 'Komfort', label: 'Komfort & Bequemlichkeit' },
      { value: 'Authentizität', label: 'Authentizität & Echtheit' },
      { value: 'Erlebnis', label: 'Erlebnis & Abenteuer' },
      { value: 'Geselligkeit', label: 'Geselligkeit & Zusammensein' }
    ]
  },
  {
    id: 'q14',
    section: 'experience',
    question: 'Welche Art von Unterbringung bevorzugen Sie?',
    options: [
      { value: ACCOMMODATION.BOUTIQUE, label: 'Boutique-Hotel' },
      { value: ACCOMMODATION.RESORT, label: 'Resort' },
      { value: ACCOMMODATION.ECO_LODGE, label: 'Eco-Lodge' },
      { value: ACCOMMODATION.AIRBNB, label: 'AirBnB' }
    ]
  },
  {
    id: 'q15',
    section: 'experience',
    question: 'Wo liegt neben der Trauung der Fokus am Hochzeitstag?',
    options: [
      { value: 'Klassische_Feier', label: 'Klassische Feier mit Dinner & Tanz' },
      { value: 'Party_BBQ', label: 'Party, Barbecue & Fingerfood' },
      { value: 'Gala', label: 'Gala-Dinner & Feuerwerk' },
      { value: 'Intim', label: 'Intime Feier & Solo-Musiker' }
    ]
  }
];

// Section transition metadata
export const sectionTransition = {
  afterQuestion: 8,
  videoPlaceholder: true,
  transitionText: 'Jetzt geht es um Ihr persönliches Hochzeitserlebnis...'
};
